import { render } from "./MediaplanDetails.vue?vue&type=template&id=4f8d5f10&scoped=true"
import script from "./MediaplanDetails.vue?vue&type=script&lang=js"
export * from "./MediaplanDetails.vue?vue&type=script&lang=js"

import "./MediaplanDetails.vue?vue&type=style&index=0&id=4f8d5f10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8d5f10"]])

export default __exports__